import React from "react";
import { useLocationConfiguration } from "../../LocationConfiguration";
import { useLanguage } from "../../Language";

export const useTranslateFacetName = function () {
  const { translate } = useLanguage();
  const { locationConfiguration } = useLocationConfiguration();
  const { facetDisplayInformations, displaySettings } =
    locationConfiguration?.pacSettings || {};

  return React.useCallback(
    (facetName: string) => {
      const match = facetDisplayInformations.find(
        ({ name }) => facetName === name
      );
      if (match) return translate(match.displayName);
      return translate(facetName);
    },
    [facetDisplayInformations, translate]
  );
};
